export default {"src":"/_next/static/media/ellipse1.10c109f2.svg","height":176,"width":176,"blurWidth":0,"blurHeight":0};